import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const HeroContent = () => <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12 lg:px-24 z-10">
    <div className="max-w-2xl text-left">
      <div className="inline-flex items-center rounded-md border border-primary bg-primary/10 px-3 py-1 text-xs font-mono font-semibold uppercase text-primary mb-4 tracking-wider">
        RGI & SEAI Registered
      </div>
      <h1 className="font-default text-5xl md:text-6xl lg:text-[64px] font-bold leading-tight tracking-tight mb-6 text-foreground">
        Plumbing, Boiler and Heat Pump Services in Dublin
      </h1>
      <p className="text-lg md:text-xl text-foreground/90 mb-8 max-w-lg font-default">
        D4 Plumbing & Heating provides professional boiler repairs and servicing, heat pump installation and maintenance, emergency plumbing call-outs and general plumbing throughout Dublin city and county, with local coverage across Dublin 4.
      </p>
      <div className="flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-4 w-full">
        <Link to="tel:+35319081819" className="w-full sm:w-auto">
          <Button size="lg" className="w-full sm:w-auto px-8 h-12 md:h-14 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 bg-primary text-white hover:bg-primary/90 border-none">
            Call 01 908 1819
          </Button>
        </Link>
        <Link to="#get-your-free-quote-today" className="w-full sm:w-auto">
          <Button variant="outline" size="lg" className="w-full sm:w-auto px-8 h-12 md:h-14 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-chart-2 text-chart-2 hover:bg-chart-2 hover:text-white">
            Get a Free Quote
          </Button>
        </Link>
        <Link to="https://wa.me/353857063869" newTab className="w-full sm:w-auto">
          <Button size="lg" className="w-full sm:w-auto px-8 h-12 md:h-14 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 bg-[#25D366] text-white hover:bg-[#25D366]/90 border-none">
            WhatsApp 085 706 3869
          </Button>
        </Link>
      </div>
    </div>
  </div>;
export default function DublinPlumbingHeatingBoilerSpecialists() {
  return <section data-section-id="240143" id="dublin-plumbing-heating-boiler-specialists" className="relative w-full bg-background overflow-hidden dark">
      {}
      <div className="hidden md:block relative w-full max-w-[1920px] mx-auto">
        <AspectRatio ratio={21 / 9}>
          <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/viessmann_boiler_installation_dublin.png')] bg-cover bg-center" />
          <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-transparent" />
          <HeroContent />
        </AspectRatio>
      </div>

      {}
      <div className="block md:hidden relative w-full">
        <AspectRatio ratio={3 / 4}>
          <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/viessmann_boiler_installation_dublin.png')] bg-cover bg-center" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/80 to-background/20" />
          <HeroContent />
        </AspectRatio>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": ["Plumber", "LocalBusiness"],
        "name": "D4 Plumbing & Heating",
        "url": "https://d4gas.ie/",
        "@id": "https://d4gas.ie/#business",
        "telephone": "+35319081819",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Dublin",
          "addressCountry": "IE"
        },
        "areaServed": ["Dublin City", "County Dublin", "Dublin 4", "Ringsend", "Sandymount", "Ballsbridge", "Donnybrook", "Irishtown"],
        "email": "info@d4gas.ie"
      })
    }} />
    </section>;
}